import Builder from 'react-native-jala-orm/src/model/Builder';
import QueryBuilder from 'react-native-jala-orm/src/query/Builder';
import _ from 'lodash';
import Expression from 'react-native-jala-orm/src/query/Expression';
import SyncableModel from './SyncableModel';
import Cycle from './Cycle';
import Pond from './Pond';

export default class Treatment extends SyncableModel {
    static name = 'Treatment'

    _fillable = [
      'id',
      'pond_id',
      'stock_id',
      'name',
      'quantity',
      'treated_at',
      'remark',
      'created_at',
      'updated_at',
      'synced_at',
      'deleted_at',
    ]

    static _parents = ['pond'];

    static endpoint = '/treatments'

    static allowReplaceUpdate = true

    static _boot() {
      super._boot();

      this.addGlobalScope('global', (query: Builder) => {
        if (_.isEmpty(query.getQuery().columns)) {
          query.select([query.qualifyColumn('*')]);
        }

        const cycle = (new Cycle()).setTable(`${query.getModel().getTable()}_cycles`);
        query.leftJoin(
          `${(new Cycle()).getTable()} as ${cycle.getTable()}`,
          (q1: QueryBuilder) => q1.whereColumn(cycle.qualifyColumn('pond_id'), query.qualifyColumn('pond_id'))
            .whereColumn(
              new Expression('DATE('
                    + `${cycle.qualifyColumn('started_at')}, `
                    + `('-' || COALESCE(${cycle.qualifyColumn('preparation_day')}, 21) || ' DAY')`
                + ')'),
              '<=',
              query.qualifyColumn('treated_at')
            ).where((q2) => {
              q2.whereColumn(query.qualifyColumn('treated_at'), '<=', cycle.qualifyColumn('finished_at'))
                .orWhereNull(cycle.qualifyColumn('finished_at'));
              q2.clause = 'join';
              return q2;
            })
        );
      });
    }

    qualifyColumn(column: string): string {
      if (column === '*') {
        return new Expression(
          `${this.getTable()}.*, `
            + `${this.qualifyColumn('cycle_id')} as cycle_id, `
            + `${this.qualifyColumn('age')} as age`
        );
      }
      if (column === 'cycle_id') {
        const cycle = (new Cycle()).setTable(`${this.getTable()}_cycles`);
        return cycle.getQualifiedKeyName();
      }
      if (column === 'age') {
        const cycle = (new Cycle()).setTable(`${this.getTable()}_cycles`);
        return new Expression(
          `(CASE WHEN ${this.qualifyColumn('cycle_id')} IS NOT NULL THEN `
              + 'MIN('
                + 'CAST(('
                  + `JULIANDAY(${this.qualifyColumn('treated_at')}) - `
                  + `JULIANDAY(${cycle.qualifyColumn('started_at')})) AS INTEGER`
              + `) + COALESCE(${cycle.qualifyColumn('initial_age')}, 0), `
              + `COALESCE(${cycle.qualifyColumn('target_cultivation_day')}, 120)`
            + ') '
          + 'ELSE null END)'
        );
      }
      return super.qualifyColumn(column);
    }

    relationPond() {
      return Pond.query().whereKey(this.pond_id);
    }

    /**
     *
     * @param query
     */
    // eslint-disable-next-line no-unused-vars,class-methods-use-this
    scopeSyncUpdateAdditionalQuery(query: Builder) {
      return query.applyScopes();
    }
}
